export const defaultImageCompression = 95